import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { PaymentMethodModel } from '../models/payment-method.model';

export class PaymentMethodsApiService extends ApiService {
  static endpoint = 'payment-methods';

  /**
   * @param {Number|null} paymentMethodId
   * @return {String}
   * @protected
   */
  static buildPaymentMethodUrl(paymentMethodId = null) {
    return this.buildUrl(paymentMethodId);
  }

  /**
   * @param {String|Number} paymentMethodId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<PaymentMethodModel>>}
   * @public
   */
  static async get(paymentMethodId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildPaymentMethodUrl(paymentMethodId), {
      ...config,
      dataModel: PaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} paymentMethodId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<PaymentMethodModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildPaymentMethodUrl(), {
      ...config,
      dataModel: PaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<PaymentMethodModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildPaymentMethodUrl(), data, {
      ...config,
      dataModel: PaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} paymentMethodId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<PaymentMethodModel>>}
   * @public
   */
  static async patch(paymentMethodId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildPaymentMethodUrl(paymentMethodId), data, {
      ...config,
      dataModel: PaymentMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} paymentMethodId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(paymentMethodId, config = {}) {
    return HttpApiClient.delete(this.buildPaymentMethodUrl(paymentMethodId), { ...config });
  }
}
